import * as Sentry from "@sentry/react";

import { envVariables } from "@/utils/envVariables";

const isEnabled = envVariables.VITE_ENVIRONMENT !== "local";

export const initSentry = () => {
  Sentry.init({
    dsn: envVariables.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    environment: envVariables.VITE_ENVIRONMENT,
    enabled: isEnabled,
  });
};

export const sendSentryMessage = (msg: string) => {
  Sentry.captureMessage(msg);
};

export const sendSentryError = ({
  error,
  message,
  shouldThrowError = true,
}: {
  error: unknown;
  message: string;
  shouldThrowError?: boolean;
}) => {
  Sentry.captureMessage(message, { extra: { error } });

  if (shouldThrowError) {
    throw new Error(message);
  }
};

// export const setSentryUser = ({ id, email }: User) => {
//   if (isEnabled) {
//     Sentry.setUser({ id, email });
//   }
// };

export const addSentryBreadcrumb = ({
  category,
  message,
  data,
}: {
  category: string;
  message: string;
  data?: Record<string, unknown>;
}) => {
  Sentry.addBreadcrumb({
    category,
    message,
    data,
  });
};
